import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { GetTravellersPipe } from "app_locobook/shared/get-travellers-pipe/get-travellers.pipe";


@NgModule({
    imports: [
        CommonModule
    ],
    exports: [GetTravellersPipe],
    declarations: [GetTravellersPipe],
    providers: [],
})
export class GetTravellersModule {
}
